var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"abou_right"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.registList.name))]),_vm._v(" "),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.registList.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6522d468","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/vip/aboutUs.vue
// module id = null
// module chunks = 